<template>
	<div class="m-blank" :style="{'height': (parseInt(unitData.height) || 0) / 2 + 'px'}">分割留白 ({{parseInt(unitData.height) || 20}}px)</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-blank {
		min-height: 40px;
		line-height: 40px;
		font-size: 12px;
		text-align: center;
		color: #999;
	}
</style>
